import { render, staticRenderFns } from "./List.vue?vue&type=template&id=4e92f3d3&scoped=true&"
import script from "./List.vue?vue&type=script&lang=js&"
export * from "./List.vue?vue&type=script&lang=js&"
import style0 from "./List.vue?vue&type=style&index=0&id=4e92f3d3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e92f3d3",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4e92f3d3')) {
      api.createRecord('4e92f3d3', component.options)
    } else {
      api.reload('4e92f3d3', component.options)
    }
    module.hot.accept("./List.vue?vue&type=template&id=4e92f3d3&scoped=true&", function () {
      api.rerender('4e92f3d3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/advocacy/List.vue"
export default component.exports